import React, { useState, useEffect } from 'react';

const AboutUs = () => {
  const slides = [
    {
      mainImage: './assets/imgs/UDC-31.jpg',
      image1: './assets/imgs/UDC-2.jpg',
      image2: './assets/imgs/UDC-3.jpg',
      content: {
        title: 'ABOUT US',
        subtitle: 'Upholding Client’s Product Integrity',
        description1:
          'Consistently delivers exceptional performance in the dry and static control packaging business. We understand the complex needs of the modern world and fast-paced industries with rigid quality control such as semiconductors, pharmaceuticals, electronics, food, and exports.',
        description2:
          'Offers comprehensive range of solutions from our various-sized packet desiccants to bulk bags and freight container desiccants, oxygen absorbers, ethylene absorbers, our HICs, custom-sized static shielding and moisture barrier bags, these are all carefully custom-made to suit your needs. We offer an unwavering dedication to provide only the finest products and top-notch service to all our clients; big or small, we are your partners in upholding product integrity.',
        logo: './assets/imgs/logo.png',
      },
    },
    {
      mainImage: './assets/imgs/UDC-10.jpg',
      image1: './assets/imgs/UDC-11.jpg',
      image2: './assets/imgs/UDC-12.jpg',
      content: {
        title: 'MISSION',
        subtitle: 'Commitment to Excellence',
        description1:
          'Our commitment to excellence is reflected in our continuous investment in facilities, equipment, research and development, products, employee efficiency, and quality service. We are dedicated to delivering superb and highly reliable performance packaging.',
        description2:
          'UDC’s main objective is to uphold our client’s product integrity. We make sure that their products maintain the same superior quality from the manufacturing processes, to packaging, to transport, to storage, and to their end users. Our desiccants also help preserve the quality of their products by prolonging their shelf-life.',
        logo: null,
      },
    },
    {
      mainImage: './assets/imgs/UDC-4.jpg',
      image1: './assets/imgs/UDC-5.jpg',
      image2: './assets/imgs/UDC-6.jpg',
      content: {
        title: 'VISION',
        subtitle: 'Building a Future with a Purpose',
        description1:
          'We strive to be the global leader in innovative and sustainable desiccant solutions, enhancing product longevity and performance across industries while driving environmental stewardship and customer satisfaction.',
        description2:
          'To become the world’s leading provider of desiccant solutions that empower businesses of all sizes to thrive by ensuring their products remain dry, protected, and of the highest quality, while fostering sustainable practices that contribute to a healthier planet.',
        logo: null,
      },
    },
  ];

  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAutoSliding, setIsAutoSliding] = useState(true);

  useEffect(() => {
    if (!isAutoSliding) return;

    const interval = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
    }, 10000); // Auto slide every 10 seconds

    return () => clearInterval(interval);
  }, [isAutoSliding, slides.length]);

  const goToPreviousSlide = () => {
    setIsAutoSliding(false);
    setCurrentSlide((prevSlide) =>
      prevSlide === 0 ? slides.length - 1 : prevSlide - 1
    );
  };

  const goToNextSlide = () => {
    setIsAutoSliding(false);
    setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
  };

  const goToSlide = (index) => {
    setIsAutoSliding(false);
    setCurrentSlide(index);
  };

  return (
    <section
      id="about-us"
      className="w-full min-h-screen bg-white flex justify-center items-center px-4 sm:px-8 lg:px-20 py-12"
    >
      <div className="container mx-auto flex flex-col justify-center items-center">
        {/* Title, Subtitle, and Images */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center justify-center">
          {/* Left Side: Title and Subtitle */}
          <div className="text-center lg:text-left px-4 sm:px-0">
            <h2 className="text-lg font-semibold text-gray-500 uppercase tracking-wider">
              {slides[currentSlide].content.title}
            </h2>
            <h1 className="text-3xl sm:text-4xl font-semibold text-[#30779b] mt-3">
              {slides[currentSlide].content.subtitle}
            </h1>
            <p
              className={`text-sm sm:text-base text-gray-600 mt-2 text-justify ${
                !slides[currentSlide].content.description1 ? 'hidden' : ''
              }`}
            >
              {slides[currentSlide].content.description1}
            </p>
          </div>

          {/* Right Side: Smaller Images */}
          <div className="grid grid-cols-2 gap-4 justify-items-center">
            <div className="bg-gray-200 rounded-xl h-24 sm:h-32 md:h-36 w-full shadow-lg">
              <img
                src={slides[currentSlide].image1}
                alt="Image 1"
                className="w-full h-full object-cover rounded-xl"
              />
            </div>
            <div className="bg-gray-200 rounded-xl h-24 sm:h-32 md:h-36 w-full shadow-lg">
              <img
                src={slides[currentSlide].image2}
                alt="Image 2"
                className="w-full h-full object-cover rounded-xl"
              />
            </div>
          </div>
        </div>

        {/* Main Image and Content Below */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mt-8 items-center justify-center">
          {/* Left Side: Larger Main Image */}
          <div className="bg-gray-200 rounded-xl w-full shadow-lg">
            <img
              src={slides[currentSlide].mainImage}
              alt="Main Image"
              className="w-full rounded-xl object-cover h-40 sm:h-48 md:h-auto lg:h-72"
            />
          </div>

          {/* Right Side: Fixed Size Text Content for Desktop and Dynamic for Mobile */}
          <div className="bg-[#202779] text-white rounded-xl p-6 shadow-lg w-full h-auto lg:h-72 md:h-68 flex flex-col justify-center">            
            <div className="text-center lg:text-left">
              {slides[currentSlide].content.logo ? (
                <img
                  src={slides[currentSlide].content.logo}
                  alt="Content Logo"
                  className="w-20 mx-auto lg:mx-0"
                />
              ) : (
                <h2 className="text-lg font-semibold">
                  {slides[currentSlide].content.title}
                </h2>
              )}
              <p className="mt-4 text-sm sm:text-base text-justify">
                {slides[currentSlide].content.description2}
              </p>
            </div>
          </div>
        </div>

        {/* Navigation Controls */}
        <div className="flex justify-between items-center mt-6 w-full lg:px-16">
          <button
            onClick={goToPreviousSlide}
            className="text-gray-600 bg-gray-200 hover:bg-gray-300 px-4 py-2 rounded-full shadow-md transition"
          >
            Previous
          </button>
          <div className="flex space-x-2">
            {slides.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`h-3 w-10 rounded-full ${
                  index === currentSlide ? 'bg-[#83b825]' : 'bg-gray-300'
                }`}
              ></button>
            ))}
          </div>
          <button
            onClick={goToNextSlide}
            className="text-gray-600 bg-gray-200 hover:bg-gray-300 px-4 py-2 rounded-full shadow-md transition"
          >
            Next
          </button>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
